<div class="dialog-common">
  <mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
  <div class="dialog-common-wrapper">
    <div mat-dialog-content>{{ dialogData.message | translate }}</div>
  </div>
</div>
